<ng-container *ngIf="loading">
  <div class="loading-container">
    <div class="loading-wrapper">
      <app-generic-loading [isLoading]="true"></app-generic-loading>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!loading">
  <div class="admin-login-container">
    <div class="admin-login-left">
      <div class="admin-logo-section">
        <img
          src="assets/images/adm-backoffice.svg"
          alt="Backoffice"
          class="admin-logo"
        />
        <div class="admin-welcome-section">
          <p class="admin-welcome-text">Olá! Que bom te ver por aqui! ;)</p>
          <p class="admin-access-text">Para acessar, entre na sua conta</p>
        </div>
      </div>
      <div class="admin-login-button">
        <button
          id="id-admin-login-btn-submit"
          type="submit"
          class="admin-btn-submit"
          (click)="submit()"
          data-testid="admin-login-submit-button"
        >
          Entrar
        </button>
      </div>
    </div>
    <div class="admin-login-right">
      <div class="admin-form-container">
        <div class="admin-illustration">
          <img
            src="assets/images/adm-login-img.svg"
            alt="Admin illustration"
            class="admin-illustration-img"
          />
        </div>
      </div>
    </div>
  </div>
</ng-container>
